import React, { Component } from 'react';
import PropTypes from 'prop-types';


export default class ListCallbackHeader extends Component {
  render() {
    const {
      iconClass,
      title,
      showAction,
      onActionClick,
      btnIcon,
      btnText,
      isLoading,
    } = this.props;
    return (
      <div className="card-header d-flex justify-content-between align-items-center">
        <span><i className={iconClass}></i>{title}</span>
        {showAction && <div>
          <button className="btn btn-primary m-0" disabled={isLoading} onClick={onActionClick}>
            <i className={`fa ${btnIcon}`}/> {isLoading ? 'Loading...' : btnText}
          </button>
        </div>}
      </div>
    )
  }
}

ListCallbackHeader.propTypes = {
  iconClass: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onActionClick: PropTypes.func.isRequired,
  showAction: PropTypes.bool,
  btnIcon: PropTypes.string,
  btnText: PropTypes.string,
  isLoading: PropTypes.bool,
}

ListCallbackHeader.defaultProps = {
  showAction: true,
  btnIcon: 'fa-plus',
  btnText: '',
  isLoading: false,
}
